import React from 'react'
import { logout } from '../Auth.ducks'
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';

function EtatAbonnement(props) {
  const { t } = useTranslation();
  return (
    <main class="main-wrapper login-page">
      <div class="container-login">
        <form class="box-login" onSubmit={(e) => {
          e.preventDefault();
          props.logout();
        }}>
          <h5 class="mb-4">{t('abonnement.account_disabled_short')}<br /><br />{t('abonnement.account_disabled_detail')}</h5>
          <button type="submit" class="btn-gradient mt-4">{t('abonnement.return')}</button>
        </form>
      </div>
    </main>
  )
}
const mapStateToProps = (state) => ({

})

const mapDispatchToProps = {
  logout
}

export default connect(mapStateToProps, mapDispatchToProps)(EtatAbonnement)